const skills = {
  skillsArray: [
    {
      _id: "1",
      icon: <i class="fab icon-cplusplus fa-2x HomeScreenSkillContentIcon"></i>,
      name: "C++",
    },
    
    {
      _id: "4",
      icon: <i class="fab fa-java fa-2x HomeScreenSkillContentIcon"></i>,
      name: "Java",
    },
    {
      _id: "2",
      icon: <i class="fab icon-c fa-2x HomeScreenSkillContentIcon"></i>,
      name: "C",
    },
    {
      _id: "3",
      icon: <i class="fab fa-python fa-2x HomeScreenSkillContentIcon"></i>,
      name: "Python",
    },
    {
      _id: "3",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="simple-icons:springboot"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "Spring Boot",
    },
    {
      _id: "5",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M14.131.047c-.173 0-.334.037-.483.087c.316.21.49.49.576.806c.007.043.019.074.025.117a.681.681 0 0 1 .013.112c.024.545-.143.614-.26.936c-.18.415-.13.861.086 1.22a.74.74 0 0 0 .074.137c-.235-1.568 1.073-1.803 1.314-2.293c.019-.428-.334-.713-.613-.911a1.37 1.37 0 0 0-.732-.21zM16.102.4c-.024.143-.006.106-.012.18c-.006.05-.006.112-.012.161c-.013.05-.025.1-.044.149c-.012.05-.03.1-.05.149l-.067.142c-.02.025-.031.05-.05.075l-.037.055a2.152 2.152 0 0 1-.093.124c-.037.038-.068.081-.112.112v.006c-.037.031-.074.068-.118.1c-.13.099-.278.173-.415.266c-.043.03-.087.056-.124.093a.906.906 0 0 0-.118.099c-.043.037-.074.074-.111.118c-.031.037-.068.08-.093.124a1.582 1.582 0 0 0-.087.13c-.025.05-.043.093-.068.142c-.019.05-.037.093-.05.143a2.007 2.007 0 0 0-.043.155c-.006.025-.006.056-.012.08c-.007.025-.007.05-.013.075c0 .05-.006.105-.006.155c0 .037 0 .074.006.111c0 .05.006.1.019.155c.006.05.018.1.03.15c.02.049.032.098.05.148c.013.03.031.062.044.087l-1.426-.552c-.241-.068-.477-.13-.719-.186l-.39-.093c-.372-.074-.75-.13-1.128-.167c-.013 0-.019-.006-.031-.006A11.082 11.082 0 0 0 8.9 2.855c-.378.025-.756.074-1.134.136a12.45 12.45 0 0 0-.837.174l-.279.074c-.092.037-.18.08-.266.118l-.205.093c-.012.006-.024.006-.03.012c-.063.031-.118.056-.174.087a2.738 2.738 0 0 0-.236.118c-.043.018-.086.043-.124.062a.559.559 0 0 1-.055.03c-.056.032-.112.063-.162.094a1.56 1.56 0 0 0-.148.093c-.044.03-.087.055-.124.086c-.006.007-.013.007-.019.013c-.037.025-.08.056-.118.087l-.012.012l-.093.074c-.012.007-.025.019-.037.025c-.031.025-.062.056-.093.08c-.006.013-.019.02-.025.025c-.037.038-.074.069-.111.106c-.007 0-.007.006-.013.012a1.742 1.742 0 0 0-.111.106c-.007.006-.007.012-.013.012a1.454 1.454 0 0 0-.093.1c-.012.012-.03.024-.043.036a1.374 1.374 0 0 1-.106.112c-.006.012-.018.019-.024.03c-.05.05-.093.1-.143.15l-.018.018c-.1.106-.205.211-.317.304c-.111.1-.229.192-.347.273a3.777 3.777 0 0 1-.762.421c-.13.056-.267.106-.403.149c-.26.056-.527.161-.756.18c-.05 0-.105.012-.155.018l-.155.037l-.149.056c-.05.019-.099.044-.148.068c-.044.031-.093.056-.137.087a1.011 1.011 0 0 0-.124.106c-.043.03-.087.074-.124.111c-.037.043-.074.08-.105.124c-.031.05-.068.093-.093.143a1.092 1.092 0 0 0-.087.142c-.025.056-.05.106-.068.161c-.019.05-.037.106-.056.161c-.012.05-.025.1-.03.15c0 .005-.007.012-.007.018c-.012.056-.012.13-.019.167C.006 7.95 0 7.986 0 8.03a.657.657 0 0 0 .074.31v.006c.019.037.044.075.069.112c.024.037.05.074.08.111c.031.031.068.069.106.1a.906.906 0 0 0 .117.099c.149.13.186.173.378.272c.031.019.062.031.1.05c.006 0 .012.006.018.006c0 .013 0 .019.006.031a1.272 1.272 0 0 0 .08.298c.02.037.032.074.05.111c.007.013.013.025.02.031c.024.05.049.093.073.137l.093.13c.031.037.069.08.106.118c.037.037.074.068.118.105c0 0 .006.006.012.006c.037.031.074.062.112.087a.986.986 0 0 0 .136.08c.043.025.093.05.142.069a.73.73 0 0 0 .124.043c.007.006.013.006.025.012c.025.007.056.013.08.019c-.018.335-.024.65.026.762c.055.124.328-.254.6-.688c-.036.428-.061.93 0 1.079c.069.155.44-.329.763-.862c4.395-1.016 8.405 2.02 8.826 6.31c-.08-.67-.905-1.041-1.283-.948c-.186.458-.502 1.047-1.01 1.413c.043-.41.025-.83-.062-1.24a4.009 4.009 0 0 1-.769 1.562c-.588.043-1.177-.242-1.487-.67c-.025-.018-.031-.055-.05-.08c-.018-.043-.037-.087-.05-.13a.515.515 0 0 1-.037-.13c-.006-.044-.006-.087-.006-.137v-.093a.992.992 0 0 1 .031-.13c.013-.043.025-.086.044-.13c.024-.043.043-.087.074-.13c.105-.298.105-.54-.087-.682a.706.706 0 0 0-.118-.062c-.024-.006-.055-.018-.08-.025l-.05-.018a.847.847 0 0 0-.13-.031a.472.472 0 0 0-.13-.019a1.01 1.01 0 0 0-.136-.012c-.031 0-.062.006-.093.006a.484.484 0 0 0-.137.019c-.043.006-.086.012-.13.024a1.068 1.068 0 0 0-.13.044c-.043.018-.08.037-.124.056c-.037.018-.074.043-.118.062c-1.444.942-.582 3.148.403 3.787c-.372.068-.75.148-.855.229l-.013.012c.267.161.546.298.837.416c.397.13.818.247 1.004.297v.006a5.996 5.996 0 0 0 1.562.112c2.746-.192 4.996-2.281 5.405-5.033l.037.161c.019.112.043.23.056.347v.006c.012.056.018.112.025.162v.024c.006.056.012.112.012.162c.006.068.012.136.012.204v.1c0 .03.007.067.007.098c0 .038-.007.075-.007.112v.087c0 .043-.006.08-.006.124c0 .025 0 .05-.006.08c0 .044-.006.087-.006.137c-.006.018-.006.037-.006.055l-.02.143c0 .019 0 .037-.005.056c-.007.062-.019.118-.025.18v.012l-.037.174v.018l-.037.167c0 .007-.007.02-.007.025a1.663 1.663 0 0 1-.043.168v.018c-.019.062-.037.118-.05.174c-.006.006-.006.012-.006.012l-.056.186c-.024.062-.043.118-.068.18c-.025.062-.043.124-.068.18c-.025.062-.05.117-.074.18h-.007c-.024.055-.05.117-.08.173a.302.302 0 0 1-.019.043c-.006.006-.006.013-.012.019a5.867 5.867 0 0 1-1.742 2.082c-.05.031-.099.069-.149.106c-.012.012-.03.018-.043.03a2.603 2.603 0 0 1-.136.094l.018.037h.007l.26-.037h.006c.161-.025.322-.056.483-.087c.044-.006.093-.019.137-.031l.087-.019c.043-.006.086-.018.13-.024c.037-.013.074-.02.111-.031c.62-.15 1.221-.354 1.798-.595a9.926 9.926 0 0 1-3.85 3.142c.714-.05 1.426-.167 2.114-.366a9.903 9.903 0 0 0 5.857-4.68a9.893 9.893 0 0 1-1.667 3.986a9.758 9.758 0 0 0 1.655-1.376a9.824 9.824 0 0 0 2.61-5.268c.21.98.272 1.99.18 2.987c4.474-6.241.371-12.712-1.346-14.416c-.006-.013-.012-.019-.012-.031c-.006.006-.006.006-.006.012c0-.006 0-.006-.007-.012c0 .074-.006.148-.012.223a8.34 8.34 0 0 1-.062.415c-.03.136-.068.273-.105.41c-.044.13-.093.266-.15.396a5.322 5.322 0 0 1-.185.378a4.735 4.735 0 0 1-.477.688c-.093.111-.192.21-.292.31a3.994 3.994 0 0 1-.18.155l-.142.124a3.459 3.459 0 0 1-.347.241a4.295 4.295 0 0 1-.366.211c-.13.062-.26.118-.39.174a4.364 4.364 0 0 1-.818.223c-.143.025-.285.037-.422.05a4.914 4.914 0 0 1-.297.012a4.66 4.66 0 0 1-.422-.025a3.137 3.137 0 0 1-.421-.062a3.136 3.136 0 0 1-.415-.105h-.007c.137-.013.273-.025.41-.05a4.493 4.493 0 0 0 .818-.223c.136-.05.266-.112.39-.174c.13-.062.248-.13.372-.204c.118-.08.235-.161.347-.248c.112-.087.217-.18.316-.279c.105-.093.198-.198.291-.304c.093-.111.18-.223.26-.334c.013-.019.026-.044.038-.062c.062-.1.124-.199.18-.298a4.272 4.272 0 0 0 .334-.775c.044-.13.075-.266.106-.403c.025-.142.05-.278.062-.415c.012-.142.025-.285.025-.421c0-.1-.007-.199-.013-.298a6.726 6.726 0 0 0-.05-.415a4.493 4.493 0 0 0-.092-.415c-.044-.13-.087-.267-.137-.397c-.05-.13-.111-.26-.173-.384c-.069-.124-.137-.248-.211-.366a6.843 6.843 0 0 0-.248-.34c-.093-.106-.186-.212-.285-.317a3.878 3.878 0 0 0-.161-.155c-.28-.217-.57-.421-.862-.607a1.154 1.154 0 0 0-.124-.062a2.415 2.415 0 0 0-.589-.26Z"
          />
        </svg>
      ),
      name: "Nest.js",
    },
    {
      _id: "8",
      icon: <i class="fab fa-node-js fa-2x HomeScreenSkillContentIcon"></i>,
      name: "NodeJs",
    },
    {
      _id: "7",
      icon: <i class="fab fa-react fa-2x HomeScreenSkillContentIcon"></i>,
      name: "React",
    },
    
    {
      _id: "3",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="simple-icons:postgresql"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "PostgreSQL",
    },
    {
      _id: "11",
      icon: <i class="fab icon-mysql-alt fa-2x HomeScreenSkillContentIcon"></i>,
      name: "MySQL",
    },
    // {
    //   _id: "7",
    //   icon: (
    //     <span
    //       class="iconify HomeScreenSkillContentIcon"
    //       data-icon="fa6-solid:circle-nodes"
    //       data-inline="false"
    //       style={{ height: "28px", width: "28px" }}
    //     ></span>
    //   ),
    //   name: "CN",
    // },
    
    
    {
      _id: "10",
      icon: <i class="fab icon-mongodb fa-2x HomeScreenSkillContentIcon"></i>,
      name: "MongoDB",
    },
    {
      _id: "3",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="simple-icons:redis"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "Redis",
    },
    
    {
      _id: "5",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="32"
          viewBox="0 0 512 208"
        >
          <defs>
            <linearGradient id="logosGrpc0" x1="100%" x2="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="#72C9C9" />
              <stop offset="100%" stop-color="#02B0AD" />
            </linearGradient>
            <linearGradient id="logosGrpc1" x1="100%" x2="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="#03B6B4" />
              <stop offset="100%" stop-color="#74CBCA" />
            </linearGradient>
          </defs>
          <path
            fill="#244B5A"
            d="M56.678 179.868a40.246 40.246 0 0 0 14.42 11.938a43.222 43.222 0 0 0 19.768 4.487a42.464 42.464 0 0 0 16.234-2.769a28.18 28.18 0 0 0 10.79-7.544a29.098 29.098 0 0 0 5.922-11.174a49.903 49.903 0 0 0 1.814-13.655v-16.043h-.381a34.445 34.445 0 0 1-14.9 12.988a45.958 45.958 0 0 1-18.525 3.82a48.184 48.184 0 0 1-18.239-3.438a46.394 46.394 0 0 1-14.803-9.455a43.5 43.5 0 0 1-9.932-14.421a45.253 45.253 0 0 1-3.628-18.144a47.463 47.463 0 0 1 3.439-18.144a46.64 46.64 0 0 1 9.453-14.706a42.642 42.642 0 0 1 14.325-9.837a46.147 46.147 0 0 1 18.24-3.533c2.849.017 5.691.272 8.498.763a40.246 40.246 0 0 1 8.977 2.675a41.352 41.352 0 0 1 17.095 13.753h.38v-14.9h12.608v88.622a71.906 71.906 0 0 1-1.815 15.47a38.212 38.212 0 0 1-7.067 15.088a40.24 40.24 0 0 1-14.611 11.462c-6.24 3.054-14.39 4.581-24.448 4.581a61.406 61.406 0 0 1-23.874-4.391A55.485 55.485 0 0 1 47.32 189.8l9.357-9.933Zm2.291-63.79a34.222 34.222 0 0 0 2.58 13.272a34.87 34.87 0 0 0 7.065 10.886a34.172 34.172 0 0 0 10.505 7.45a30.912 30.912 0 0 0 13.083 2.77a35.036 35.036 0 0 0 24.065-9.454a30.428 30.428 0 0 0 7.354-10.793a34.762 34.762 0 0 0 2.388-14.132a38.025 38.025 0 0 0-2.292-13.275a31.883 31.883 0 0 0-6.686-10.886a32.304 32.304 0 0 0-10.695-7.449a34.815 34.815 0 0 0-14.134-2.77a30.94 30.94 0 0 0-13.083 2.77a34.266 34.266 0 0 0-10.505 7.449a34.947 34.947 0 0 0-7.067 10.886a34.249 34.249 0 0 0-2.578 13.275Zm130.638 45.838h-13.75V26.69h41.636c13.751 0 24.606 2.992 32.564 8.977c7.957 5.986 11.936 15.027 11.938 27.121a33.791 33.791 0 0 1-8.881 23.778c-5.922 6.432-14.485 10.156-25.689 11.173l38.963 64.177h-16.809l-37.05-62.838h-22.92l-.002 62.838Zm0-75.444h24.448a54.954 54.954 0 0 0 15.566-1.91a28.907 28.907 0 0 0 10.219-5.06a18.482 18.482 0 0 0 5.538-7.449a24.716 24.716 0 0 0 1.719-9.265a24.212 24.212 0 0 0-1.72-9.07a19.22 19.22 0 0 0-5.537-7.546a27.013 27.013 0 0 0-10.22-5.062a57.796 57.796 0 0 0-15.565-1.813h-24.448v47.175ZM290.068 26.69h39.346c13.75 0 24.605 2.993 32.563 8.978c7.957 5.986 11.936 15.027 11.938 27.122c0 12.098-3.98 21.17-11.938 27.215c-7.958 6.05-18.812 9.074-32.563 9.073h-25.593v62.838h-13.753V26.69Zm13.755 59.784h22.155a54.969 54.969 0 0 0 15.566-1.911a28.923 28.923 0 0 0 10.218-5.06a18.49 18.49 0 0 0 5.538-7.449a24.696 24.696 0 0 0 1.72-9.264a24.192 24.192 0 0 0-1.72-9.071a19.227 19.227 0 0 0-5.538-7.546a27.027 27.027 0 0 0-10.218-5.061a57.81 57.81 0 0 0-15.566-1.814h-22.157l.001 47.176ZM512 140.524a52.447 52.447 0 0 1-8.497 9.741a53.718 53.718 0 0 1-11.556 7.925a65.907 65.907 0 0 1-14.037 5.254a64.865 64.865 0 0 1-15.95 1.91a72.337 72.337 0 0 1-27.979-5.348a67.123 67.123 0 0 1-37.149-37.244a74.005 74.005 0 0 1-5.347-28.46a74.01 74.01 0 0 1 5.347-28.458a67.115 67.115 0 0 1 37.15-37.242a72.32 72.32 0 0 1 27.978-5.348a68.361 68.361 0 0 1 25.212 4.964a50.855 50.855 0 0 1 21.581 16.427l-12.03 8.977a32.925 32.925 0 0 0-5.732-6.495a41.835 41.835 0 0 0-8.306-5.729a51.866 51.866 0 0 0-10.029-4.01a38.797 38.797 0 0 0-10.696-1.529a54.855 54.855 0 0 0-23.3 4.775a52.918 52.918 0 0 0-17.475 12.795A56.294 56.294 0 0 0 410.2 72.053a66.723 66.723 0 0 0 0 44.5a56.27 56.27 0 0 0 10.984 18.622a52.853 52.853 0 0 0 17.475 12.796a54.796 54.796 0 0 0 23.3 4.777a59.045 59.045 0 0 0 10.6-.956a44.027 44.027 0 0 0 10.315-3.246a39.027 39.027 0 0 0 9.55-6.21a46.028 46.028 0 0 0 8.307-9.833L512 140.524Z"
          />
          <path
            fill="url(#logosGrpc0)"
            d="M10.392 10.392h50.18v50.18h-50.18z"
            transform="rotate(-135.213 35.482 35.482)"
          />
          <path
            fill="url(#logosGrpc1)"
            d="M117.73 20.346h29.433v29.433H117.73z"
            transform="rotate(-135.213 132.446 35.063)"
          />
          <path
            fill="#244B5A"
            d="M36.909 14.027L15.502 35.595l21.567 21.407l18.245-.067l-19.133-18.98l94.477-.35l-8.28 8.336l9.123-.033l10.704-10.784l-10.784-10.703l-9.123.033l8.343 8.277l-94.477.35l18.99-19.121z"
          />
        </svg>
      ),
      name: "gRPC",
    },
    
    {
      _id: "Redux",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="simple-icons:redux"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "Redux",
    },
    {
      _id: "Yarn",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="file-icons:yarn"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "Yarn",
    },
    {
      _id: "npm",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="teenyicons:npm-solid"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "NPM",
    },
    {
      _id: "5",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="currentColor"
          class="bi bi-file-earmark-binary-fill"
          viewBox="0 0 16 16"
        >
          <path d="M5.526 10.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z" />
          <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-2.45 8.385c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z" />
        </svg>
      ),
      name: "DSA",
    },
    {
      _id: "7",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="iconoir:code-brackets-square"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "OOPs",
    },
    {
      _id: "7",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="iconoir:mac-os-window"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "OS",
    },
    {
      _id: "7",
      icon: (
        <span
          class="iconify HomeScreenSkillContentIcon"
          data-icon="fluent:book-database-24-regular"
          data-inline="false"
          style={{ height: "28px", width: "28px" }}
        ></span>
      ),
      name: "DBMS",
    },
    

    // {
    //   _id: "6",
    //   icon: <i class="fab fa-android fa-2x HomeScreenSkillContentIcon"></i>,
    //   name: "Android",
    // },
    // {
    //   _id: "9",
    //   icon: (
    //     <span
    //       class="iconify HomeScreenSkillContentIcon"
    //       data-icon="simple-icons:firebase"
    //       data-inline="false"
    //       style={{ height: "28px", width: "28px" }}
    //     ></span>
    //   ),
    //   name: "Firebase",
    // },

    // {
    //   _id: "15",
    //   icon: <i class="fab fa-github fa-2x HomeScreenSkillContentIcon"></i>,
    //   name: "Github",
    // },
    {
      _id: "16",
      icon: <i class="fab fa-git-alt fa-2x HomeScreenSkillContentIcon"></i>,
      name: "Git",
    },
    // {
    //   _id: "12",
    //   icon: <i class="fab icon-heroku fa-2x HomeScreenSkillContentIcon"></i>,
    //   name: "Heroku",
    // },
    // {
    //   _id: "13",
    //   icon: <i class="fas fa-robot  fa-2x HomeScreenSkillContentIcon"></i>,
    //   name: "ML",
    // },
    // {
    //   _id: "14",
    //   icon: (
    //     <span
    //       class="iconify HomeScreenSkillContentIcon"
    //       data-icon="file-icons:opencv"
    //       data-inline="false"
    //       style={{ height: "28px", width: "28px" }}
    //     ></span>
    //   ),
    //   name: "OpenCV",
    // },

    // {
    //   _id: "17",
    //   icon: <i class="fab fa-bootstrap fa-2x HomeScreenSkillContentIcon"></i>,
    //   name: "Bootstrap",
    // },
    {
      _id: "18",
      icon: <i class="fab fa-html5 fa-2x HomeScreenSkillContentIcon"></i>,
      name: "HTML",
    },
    {
      _id: "19",
      icon: <i class="fab fa-css3-alt fa-2x HomeScreenSkillContentIcon"></i>,
      name: "CSS",
    },
    {
      _id: "20",
      icon: <i class="fab icon-sass fa-2x HomeScreenSkillContentIcon"></i>,
      name: "SASS",
    },
  ],
};
export default skills;
